import { Navigate, useNavigate } from 'react-router-dom';
import BottomNav from '../components/BottomNav';
import BrandMark from '../components/BrandMark';
import ThemeToggle from '../components/ThemeToggle';
import { useSession, signOut } from '../auth/session';
import { useSync } from '../sync/useSync';
import PushToggle from '../components/PushToggle';

export default function Profile() {
  const session = useSession();
  const nav = useNavigate();
  const { pending, rejected } = useSync();

  // admins manage their account inside the admin panel, not this operator screen
  if (session?.role === 'admin') return <Navigate to="/admin/account" replace />;

  return (
    <div className="app has-bottomnav">
      <div className="spread" style={{ marginBottom: 8 }}>
        <BrandMark />
        <ThemeToggle />
      </div>
      <h1>Profile</h1>

      {session ? (
        <>
          <div className="card">
            <div className="row"><span className="k">Name</span><span className="v">{session.operatorName}</span></div>
            <div className="row"><span className="k">Employee ID</span><span className="v">{session.operatorId}</span></div>
            <div className="row"><span className="k">Role</span><span className="v" style={{ textTransform: 'capitalize' }}>{session.role}</span></div>
          </div>

          <PushToggle />

          {rejected > 0 && (
            <button className="secondary" onClick={() => nav('/pending')} style={{ borderColor: 'var(--bad)', color: 'var(--bad)' }}>
              ⚠️ {rejected} reading{rejected > 1 ? 's' : ''} rejected — tap to review
            </button>
          )}
          {pending > 0 && (
            <button className="secondary" onClick={() => nav('/pending')}>
              ⏳ {pending} reading{pending > 1 ? 's' : ''} waiting to sync
            </button>
          )}
          <button className="secondary" onClick={() => nav('/scan')}>Scan / log a reading</button>
          <button className="secondary" onClick={() => { signOut(); nav('/signin', { replace: true }); }}>Sign out</button>

          <p className="center muted tiny" style={{ marginTop: 18 }}>You stay signed in on this device until you sign out.</p>
        </>
      ) : (
        <div className="card center pad">
          <div style={{ fontSize: 40 }}>👤</div>
          <p className="muted">You are not signed in.</p>
          <button onClick={() => nav('/signin')}>Sign in</button>
        </div>
      )}

      <BottomNav />
    </div>
  );
}
